import { Skill } from "@seneca/course-service-types";

import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";
import {
  getMany as getContentModules,
  getExisting as getExistingContentModules,
  listMany as listContentModules,
  listExisting as listExistingContentModules
} from "seneca-common/utils/selectors/map-query";

import { ContentId } from "../../../models/state/contents/content/Content";
import { ModuleId } from "../../../models/state/modules/module/ContentModule";
import { Modules } from "../../../models/state/modules/Modules";
import * as moduleSelectors from "./module";

export {
  getContentModules,
  getExistingContentModules,
  listContentModules,
  listExistingContentModules
};

export function getContentModule(modules: Modules, moduleId: ModuleId) {
  return modules.get(moduleId);
}

// @ts-ignore
export const getContentModuleId: (
  modules: Modules,
  moduleIds: ModuleId
) => ModuleId =
  // @ts-ignore
  composeSelector(getContentModule, moduleSelectors.getId);

// @ts-ignore
export const getContentModuleSkill: (
  modules: Modules,
  moduleIds: ModuleId
) => Skill =
  // @ts-ignore
  composeSelector(getContentModule, moduleSelectors.getSkill);

// @ts-ignore
export const getContentModuleTextToSpeechDisabled: (
  modules: Modules,
  moduleIds: ModuleId
) => boolean = composeSelector(
  // @ts-ignore
  getContentModule,
  moduleSelectors.getModuleTextToSpeechDisabled
);

// @ts-ignore
export const getContentModuleParentId: (
  modules: Modules,
  moduleIds: ModuleId
  // @ts-ignore
) => ContentId = composeSelector(getContentModule, moduleSelectors.getParentId);

export const getContentModuleType: (
  modules: Modules,
  moduleIds: ModuleId
) => string =
  // @ts-ignore
  composeSelector(getContentModule, moduleSelectors.getModuleType);

export const getContentModuleContent: <C>(
  modules: Modules,
  moduleIds: ModuleId
) => C =
  // @ts-ignore
  composeSelector(getContentModule, moduleSelectors.getModuleContent);

// @ts-ignore
export const getContentModuleDifficulty: (
  modules: Modules,
  moduleId: ModuleId
) => number = composeSelector(
  // @ts-ignore
  getContentModule,
  moduleSelectors.getModuleDifficulty
);
